import { Injectable, inject } from '@angular/core';
import { FilesState } from '@shared';

/**
 * Use case for clearing file upload state.
 * Provides controlled state mutation for the presentation layer.
 */
@Injectable({ providedIn: 'root' })
export class ClearFilesStateUseCase {
  private readonly _state = inject(FilesState);

  /**
   * Clears all upload state (files, progress, errors).
   */
  public execute(): void {
    this._state.clear();
  }
}
